import React, { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";

const ParticleBurst = ({ onComplete }) => {
    const [init, setInit] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadFull(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const particlesLoaded = (container) => {
        setTimeout(() => {
            if (container) {
                container.destroy();
            }
            if (onComplete) {
                onComplete();
            }
        }, 500);
    };

    const options = {
        fullScreen: {
            enable: true,
            zIndex: 100
        },
        particles: {
            number: {
                value: 0
            },
            color: {
                value: ["#FFD700", "#FFA500", "#FF4500", "#FF6347"]
            },
            shape: {
                type: "star",
            },
            opacity: {
                value: { min: 0.5, max: 1 },
                animation: {
                    enable: true,
                    speed: 1,
                    sync: false
                }
            },
            size: {
                value: { min: 2, max: 5 }
            },
            move: {
                enable: true,
                speed: 6,
                direction: "none",
                outModes: {
                    default: "destroy"
                }
            }
        },
        interactivity: {
            detectsOn: "canvas",
            events: {
                resize: true
            }
        },
        emitters: {
            direction: "none",
            rate: {
                quantity: 100,
                delay: 0.1
            },
            position: {
                x: 50,
                y: 50
            },
            size: {
                width: 10,
                height: 10
            },
            life: {
                count: 1,
                duration: 0.1,
                delay: 0.4
            }
        }
    };

    if (init) {
        return (
            <Particles
                id="tsparticles"
                particlesLoaded={particlesLoaded}
                options={options}
            />
        );
    }

    return null;
};

export default ParticleBurst;
